import React from 'react';
import classnames from 'classnames';
import {NavLink} from 'react-router-dom';
import styles from './MenuItem.module.scss';

export interface MenuItemProps {
  link: string
  label: React.ReactNode
  className?: string
  onClick?: () => void | Promise<void>
}

const MenuItem = ({link, className, label, onClick}: MenuItemProps) => {
  return (
    <NavLink
      to={link}
      className={classnames(styles.menuItem, className)}
      onClick={async () => {
        if (onClick) {
          await onClick();
        }
      }}
    >
      {label}
    </NavLink>
  );
};

export default MenuItem;
